import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  return <AnimatePresence data-id="element-141">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[60] pointer-events-none" data-id="element-142" />
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-id="element-143">
            <div className="absolute inset-0" onClick={onClose} data-id="element-144" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#0a0a0a] border border-white/10 rounded-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden shadow-2xl relative z-10" data-id="element-145">
              <div className="sticky top-0 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10 px-6 py-4 flex items-center justify-between" data-id="element-146">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-147">
                  Política de Privacidad y Protección de Datos
                </h2>
                <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-colors" data-id="element-148">
                  <XIcon className="w-5 h-5 text-gray-400" data-id="element-149" />
                </button>
              </div>

              <div className="px-6 py-8 overflow-y-auto max-h-[calc(85vh-80px)] text-gray-300 space-y-6" data-id="element-150">
                <section data-id="element-151">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-152">
                    1. INTRODUCCIÓN
                  </h3>
                  <p className="leading-relaxed" data-id="element-153">
                    En TicketMaestro y Benefika valoramos y respetamos la
                    privacidad de nuestros usuarios. Esta Política de Privacidad
                    describe cómo recopilamos, utilizamos, almacenamos y
                    protegemos los datos personales que usted nos proporciona al
                    utilizar nuestros sitios, APPs, terminales de autoatención u
                    otros sistemas o canales de comunicación.
                  </p>
                </section>

                <section data-id="element-154">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-155">
                    2. RESPONSABLE DEL TRATAMIENTO
                  </h3>
                  <p className="leading-relaxed" data-id="element-156">
                    <strong className="text-white" data-id="element-157">
                      Nombre de la entidad:
                    </strong>{' '}
                    TicketMaestro SAS
                    <br data-id="element-158" />
                    <strong className="text-white" data-id="element-159">
                      Dirección Legal:
                    </strong>{' '}
                    Edificio The Point, Oficina 1803, Puerto Santa Ana,
                    Guayaquil, Ecuador.
                    <br data-id="element-160" />
                    <strong className="text-white" data-id="element-161">
                      Correo electrónico de contacto:
                    </strong>{' '}
                    protecciondatos@benefika.net
                  </p>
                </section>

                <section data-id="element-162">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-163">
                    3. DATOS PERSONALES QUE RECOPILAMOS
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-164">
                    Podemos recopilar los siguientes datos personales cuando
                    navegas o interactúas con nuestro sitio web u otros canales:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-165">
                    <li data-id="element-166">Nombres y apellidos</li>
                    <li data-id="element-167">Número de Cédula</li>
                    <li data-id="element-168">Correo electrónico</li>
                    <li data-id="element-169">Número de teléfono</li>
                    <li data-id="element-170">
                      Dirección IP y datos de navegación (cookies, ubicación,
                      tipo de navegador)
                    </li>
                    <li data-id="element-171">
                      Información proporcionada mediante formularios de contacto
                      o suscripción
                    </li>
                  </ul>
                </section>

                <section data-id="element-172">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-173">
                    4. FINALIDAD DEL TRATAMIENTO
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-174">
                    Recopilamos tus datos con las siguientes finalidades:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-175">
                    <li data-id="element-176">
                      Enviar información institucional, boletines, eventos,
                      productos y servicios
                    </li>
                    <li data-id="element-177">
                      Atender consultas o solicitudes realizadas a través de
                      formularios de contacto
                    </li>
                    <li data-id="element-178">Gestionar inscripciones a eventos o programas</li>
                    <li data-id="element-179">
                      Gestionar promociones, beneficios, sistemas de
                      fidelización y otras actividades de marketing
                    </li>
                    <li data-id="element-180">
                      Realizar análisis estadísticos de navegación (uso de
                      cookies)
                    </li>
                    <li data-id="element-181">Cumplir con obligaciones legales y regulatorias</li>
                  </ul>
                </section>

                <section data-id="element-182">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-183">
                    5. LEGITIMACIÓN PARA EL TRATAMIENTO
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-184">
                    El tratamiento de tus datos se realiza con base en:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-185">
                    <li data-id="element-186">Tu consentimiento expreso</li>
                    <li data-id="element-187">
                      El interés legítimo de PromRed para cumplir su misión
                      institucional
                    </li>
                    <li data-id="element-188">
                      El cumplimiento de obligaciones legales, según la
                      normativa ecuatoriana aplicable (Ley Orgánica de
                      Protección de Datos Personales – LOPDP)
                    </li>
                  </ul>
                </section>

                <section data-id="element-189">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-190">
                    6. DESTINATARIOS DE LOS DATOS
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-191">
                    Tus datos personales no serán compartidos con terceros,
                    salvo que:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-192">
                    <li data-id="element-193">Tengamos tu consentimiento previo</li>
                    <li data-id="element-194">
                      Sea requerido por autoridad competente conforme a la ley
                    </li>
                    <li data-id="element-195">
                      Se usen herramientas tecnológicas de terceros (por
                      ejemplo, para envío de newsletters, CRM o formularios) con
                      contratos que garantizan la protección de tus datos
                    </li>
                  </ul>
                </section>

                <section data-id="element-196">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-197">
                    7. DERECHOS DEL TITULAR DE LOS DATOS
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-198">Tienes derecho a:</p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-199">
                    <li data-id="element-200">Acceder a tus datos personales</li>
                    <li data-id="element-201">Rectificar datos inexactos o incompletos</li>
                    <li data-id="element-202">Eliminar tus datos (cuando proceda)</li>
                    <li data-id="element-203">Oponerte al tratamiento</li>
                    <li data-id="element-204">Solicitar la portabilidad de tus datos</li>
                    <li data-id="element-205">Revocar el consentimiento en cualquier momento</li>
                  </ul>
                  <p className="leading-relaxed mt-3" data-id="element-206">
                    Puedes ejercer estos derechos escribiéndonos a{' '}
                    <span className="text-[#d4af37]" data-id="element-207">
                      protecciondatos@benefika.net
                    </span>
                  </p>
                </section>

                <section data-id="element-208">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-209">
                    8. USO DE COOKIES
                  </h3>
                  <p className="leading-relaxed" data-id="element-210">
                    Nuestros sitios utilizan cookies propias y de terceros para
                    mejorar la experiencia de navegación y análisis del tráfico.
                    Puedes aceptar, configurar o rechazar el uso de cookies
                    desde el banner de consentimiento al ingresar al sitio.
                  </p>
                </section>

                <section data-id="element-211">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-212">
                    9. SEGURIDAD DE LA INFORMACIÓN
                  </h3>
                  <p className="leading-relaxed" data-id="element-213">
                    PromRed aplica medidas de seguridad técnicas y organizativas
                    adecuadas para proteger tus datos personales contra accesos
                    no autorizados, pérdida, destrucción o alteración.
                  </p>
                </section>

                <section data-id="element-214">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-215">
                    10. CONSERVACIÓN DE LOS DATOS
                  </h3>
                  <p className="leading-relaxed" data-id="element-216">
                    Tus datos serán conservados solo durante el tiempo necesario
                    para cumplir con la finalidad para la que fueron recopilados
                    o mientras exista una relación institucional o contractual.
                    Posteriormente serán eliminados o anonimizados, según
                    corresponda.
                  </p>
                </section>

                <section data-id="element-217">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-218">
                    11. CAMBIOS A ESTA POLÍTICA
                  </h3>
                  <p className="leading-relaxed" data-id="element-219">
                    Nos reservamos el derecho de modificar esta Política de
                    Privacidad en cualquier momento. Cualquier cambio será
                    publicado con la fecha de actualización correspondiente.
                  </p>
                </section>

                <section data-id="element-220">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-221">
                    12. AUTORIDAD DE CONTROL
                  </h3>
                  <p className="leading-relaxed" data-id="element-222">
                    Si consideras que tus derechos no han sido respetados,
                    puedes presentar un reclamo ante la Autoridad de Protección
                    de Datos Personales de Ecuador, la Superintendencia de
                    Protección de Datos Personales.
                  </p>
                </section>

                <section data-id="element-223">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-224">
                    13. VIGENCIA
                  </h3>
                  <p className="leading-relaxed" data-id="element-225">
                    La vigencia de estas Políticas de Privacidad y Protección de
                    Datos es desde el 21 de noviembre de 2025 y permanecerá
                    vigente hasta que exista una nueva versión que la reemplace.
                  </p>
                </section>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}